import { useContext } from "react";

import { AuthContext } from "../provider/Auth";

const useAuth = () => useContext(AuthContext);

export default useAuth;
